import { RightArrow2Outlined } from 'dd-icons';
import './AdviceHistory.less'
import { _getHistoryAdviceList } from '@/api/user'
import { useEffect, useState } from 'react';
import useHistory from '@/hooks/useHistory'

const AdviceHistory = () => {
  const [list, setList] = useState([])
  const history = useHistory()
  

  const getHistoryList = () => {
    _getHistoryAdviceList().then(res => {
      const [d, result] = res
      if (d && result && result.length > 0) {
        setList(result)
      }
    })
  }

  const handleClick = (id) => {
    history.push('/AdviceDetail?id=' + id, 'route')
  }

  useEffect(() => {
    getHistoryList()
  }, [])

  return (
    <div className="pg-advice-history">
      <img className='header' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/advice/advice-header.png' />
      <div className='pg-advice-history--wrap'>
        <div className="pg-advice-history--container">
          {
            list.map(item => {
              return (
                <div className="row" key={ item.id } onClick={() => handleClick(item.id)}>
                  <div className='label'>
                    <div className='title'>{ item.title }</div>
                    <div className='time'>{ item.submitDate }</div>
                  </div>
                  <RightArrow2Outlined className='icon' />
                </div>
              )
            })
          }
          <div className='no-more'>没有更多了~</div>
        </div>
      </div>
    </div>
  )
}

export default AdviceHistory